import { Controller } from "stimulus"

export default class extends Controller {
  initialize() {
    setTimeout(function() {
      $(".alert").fadeOut('slow')
    }, 5000)
  }
}
